import type { ReactNode } from 'react';
import { useNavigate } from '@repo/poly-hooks/routing';
import { CustomerLogosBar } from '@repo/shared-kit/components/welcome-landing/customer-logos-bar';
import { WelcomeLanding } from '@repo/shared-kit/components/welcome-landing/welcome-landing';
import { ContentWrapper } from '../content-wrapper';
import { MainLayout } from '../layouts/main';
import { WelcomePromoBanner } from '../welcome-promo-banner/welcome-promo-banner';
import { useWelcomeContent } from './hooks';

interface WelcomeIndexPageProps {
  redirectionId: string;
  legalFlow: string;
  ownerFirstName?: string;
  organizationName?: string;
  isEmbedded?: boolean;
  isAccountant?: boolean;
  partnerName?: string;
  organizationLegalCountry: 'FR' | 'DE';
  companyCreationFromScratch?: boolean;
}

export function WelcomeIndexPage({
  redirectionId,
  legalFlow,
  ownerFirstName,
  organizationName,
  isEmbedded,
  isAccountant,
  partnerName,
  organizationLegalCountry,
  companyCreationFromScratch = false,
}: WelcomeIndexPageProps): ReactNode {
  const navigate = useNavigate();
  const {
    ctaLabel,
    featuresList,
    illustrationSrc,
    shouldShowPromoBanner,
    socialProofLabel,
    subtitle,
    title,
  } = useWelcomeContent({
    companyCreationFromScratch,
    isAccountant,
    isEmbedded,
    legalFlow,
    organizationName,
    ownerFirstName,
    partnerName,
  });

  return (
    <MainLayout promoBanner={shouldShowPromoBanner ? <WelcomePromoBanner /> : null}>
      <ContentWrapper>
        <WelcomeLanding
          featuresList={featuresList}
          illustration={
            <img alt="" data-test-welcome-illustration role="presentation" src={illustrationSrc} />
          }
          logosBar={<CustomerLogosBar country={organizationLegalCountry} />}
          primaryAction={{
            label: ctaLabel,
            onPress: () => {
              navigate(`/${redirectionId}/email-confirmation`);
            },
          }}
          socialProofLabel={socialProofLabel}
          subtitle={subtitle}
          title={title}
        />
      </ContentWrapper>
    </MainLayout>
  );
}
